import { FC, MouseEvent } from 'react';
import Checkmark from 'components/Icons/Checkmark';
import TrashOutlined from 'components/Icons/TrashOutlined';

export interface UIFileBadgeProps {
  title: string;
  fileName: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
  // eslint-disable-next-line no-unused-vars
  onRemoveClick: (event: MouseEvent<HTMLSpanElement>) => void;
}

const UIFileBadge: FC<UIFileBadgeProps> = ({
  title,
  fileName,
  onClick,
  onRemoveClick
}) => {
  return (
    <div
      className="flex cursor-pointer items-center rounded-[3px] bg-brand-grey650 px-[20px] py-[15px] text-brand-black100"
      onClick={onClick}>
      <div className="mr-[12px] flex h-[32px] w-[32px] flex-shrink-0 items-center justify-center rounded-full bg-brand-orange">
        <Checkmark fill="#fff" />
      </div>
      <div className="flex flex-auto flex-col overflow-hidden">
        <span className="mb-[1px] font-medium">{title}</span>
        <span className="overflow-hidden overflow-ellipsis whitespace-nowrap text-[12px] text-brand-grey450">
          {fileName}
        </span>
      </div>
      {!!onRemoveClick && (
        <span
          className="ml-[12px] flex h-[40px] w-[40px] flex-shrink-0 items-center justify-center rounded-[2px] bg-white text-brand-black100 transition-colors duration-200 hover:text-brand-orange"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            onRemoveClick(event);
          }}>
          <TrashOutlined fill="#00AEC7" />
        </span>
      )}
    </div>
  );
};

export default UIFileBadge;
